import { TruckBoxIcon, TruckNopIcon } from '#/shared/ui/icons'

export function CardVehicle({
  name,
  inoperable,
  enclosed,
}: {
  name: string
  inoperable?: boolean
  enclosed?: boolean
}) {
  if (!name) return null

  return (
    <div className="flex items-center gap-1.25">
      <span className="min-w-0 truncate text-sm text-gray-900">{name}</span>
      {inoperable && (
        <TruckNopIcon className="size-3.5 shrink-0 text-destructive" />
      )}
      {enclosed && <TruckBoxIcon className="size-3.5 shrink-0 text-gray-500" />}
    </div>
  )
}
